import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Scissors, Sparkles, Beer, Coffee, Wine, Gift } from 'lucide-react';
const giftCards = [{
  id: 1,
  title: 'Cortes Old School + Arreglo de Barba',
  desc: 'El ritual completo. Corte clásico y arreglo de barba con toalla caliente.',
  icon: Scissors,
  price: '$25.000'
}, {
  id: 2,
  title: 'Afeitado Tradicional',
  desc: 'Navaja, toalla caliente y productos premium. Piel perfecta, sin irritación.',
  icon: Sparkles,
  price: '$18.000'
}, {
  id: 3,
  title: 'Rapado + Afeitado Tradicional',
  desc: 'Un look limpio y definido. Rapado a máquina y afeitado clásico.',
  icon: Scissors,
  price: '$22.000'
}, {
  id: 4,
  title: 'Getting Ready — Servicio para el Novio',
  desc: 'Cerramos el salón para vos. Tragos, música y el mejor look para tu gran día.',
  icon: Wine,
  price: 'A convenir',
  isConsult: true
}, {
  id: 5,
  title: 'Afeitado Tradicional + Birra',
  desc: 'Relajate con una cerveza fría mientras disfrutás del afeitado clásico.',
  icon: Beer,
  price: '$21.000'
}, {
  id: 6,
  title: 'Cortes Old School + Arreglo de Barba + Café',
  desc: 'El servicio completo acompañado de un café de especialidad.',
  icon: Coffee,
  price: '$28.000'
}];
const leatherStyle: React.CSSProperties = {
  background: `
    repeating-linear-gradient(
      45deg,
      rgba(255,255,255,0.015) 0px,
      rgba(255,255,255,0.015) 1px,
      transparent 1px,
      transparent 8px
    ),
    repeating-linear-gradient(
      -45deg,
      rgba(255,255,255,0.015) 0px,
      rgba(255,255,255,0.015) 1px,
      transparent 1px,
      transparent 8px
    ),
    linear-gradient(160deg, #1a1008 0%, #0d0d0d 40%, #1a1008 100%)
  `
};
export function GiftCardsSection() {
  return <section id="gift-cards" className="pt-12 pb-24 px-6 bg-rotterdam-dark" data-id="element-89">
      <div className="max-w-6xl mx-auto" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-10" data-id="element-91">
          <Gift className="w-14 h-14 mx-auto mb-8 text-rotterdam-gold pearl-icon" data-id="element-92" />
          <h2 className="text-4xl md:text-6xl font-serif font-bold tracking-tight mb-6 uppercase leading-tight" data-id="element-93">
            Regalá una <br data-id="element-94" />
            <span className="text-rotterdam-gold pearl-text" data-id="element-95">
              Experiencia Exclusiva
            </span>
          </h2>
          <p className="text-lg md:text-xl text-rotterdam-cream/75 max-w-2xl mx-auto leading-relaxed font-light" data-id="element-96">
            Sorprendé a esa persona especial con una Gift Card de nuestra
            barbería. Viví una experiencia de estilo y cuidado personal, donde
            cada detalle está pensado para brindar un momento único.
          </p>
        </motion.div>

        <div className="rounded-2xl p-4 max-w-4xl mx-auto" style={{
        backgroundColor: '#C4A882'
      }} data-id="element-97">
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4" data-id="element-98">
            {giftCards.map((card, index) => <motion.div key={card.id} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} whileHover={{
            y: -6,
            transition: {
              duration: 0.3
            }
          }} className="flex flex-col group cursor-pointer" data-id="element-99">
                <a href="https://es.wikipedia.org/wiki/Toro_de_lidia" target="_blank" rel="noopener noreferrer" className="block w-full h-full" data-id="element-100">
                  <div className="relative w-full rounded-xl overflow-hidden border border-[#6BB8D4]/25 flex flex-col justify-between p-3 sm:p-4" style={{
                ...leatherStyle,
                aspectRatio: '3/4',
                boxShadow: '0 6px 30px rgba(0,0,0,0.6), 0 0 0 1px rgba(107,184,212,0.08)'
              }} data-id="element-101">
                    {/* Hover glow border */}
                    <div className="absolute inset-0 rounded-lg border border-rotterdam-gold/0 group-hover:border-rotterdam-gold/50 transition-all duration-500 pointer-events-none" data-id="element-102" />

                    {/* Top */}
                    <div className="relative z-10 flex justify-between items-start" data-id="element-103">
                      <span className="text-rotterdam-gold pearl-text font-serif font-bold tracking-[0.2em] text-[10px] uppercase" data-id="element-104">
                        Gift Card
                      </span>
                      <card.icon className="w-4 h-4 text-rotterdam-gold pearl-icon opacity-70" data-id="element-105" />
                    </div>

                    {/* Middle */}
                    <div className="relative z-10 flex flex-col items-center text-center gap-2" data-id="element-106">
                      <div className="w-10 h-10 rounded-full border-2 border-rotterdam-gold/40 flex items-center justify-center" style={{
                    boxShadow: '0 0 10px rgba(107,184,212,0.2)'
                  }} data-id="element-107">
                        <span className="font-serif text-rotterdam-gold pearl-text text-lg italic font-bold" data-id="element-108">
                          R
                        </span>
                      </div>
                      <div data-id="element-109">
                        <p className="font-serif text-rotterdam-cream/50 text-[10px] tracking-widest uppercase mb-0.5" data-id="element-110">
                          Rotterdam
                        </p>
                        <h4 className="font-serif text-white text-base font-bold leading-tight" data-id="element-111">
                          Barbería
                        </h4>
                      </div>
                      <div className="w-10 h-px bg-rotterdam-gold/40" data-id="element-112" />
                      <h3 className="font-serif text-rotterdam-cream font-semibold text-sm leading-snug px-1" data-id="element-113">
                        {card.title}
                      </h3>
                      <p className="text-rotterdam-cream/50 text-[11px] leading-relaxed px-1" data-id="element-114">
                        {card.desc}
                      </p>
                    </div>

                    {/* Bottom */}
                    <div className="relative z-10 flex flex-col items-center gap-1" data-id="element-115">
                      {card.isConsult ? <span className="px-4 py-1.5 border border-rotterdam-gold/60 text-rotterdam-gold pearl-text text-[10px] font-bold tracking-widest uppercase rounded-full group-hover:bg-rotterdam-gold/10 transition-colors" data-id="element-116">
                          Consultanos
                        </span> : <span className="text-rotterdam-gold pearl-text font-bold text-xs tracking-wider" data-id="element-117">
                          {card.price}
                        </span>}
                      <span className="text-rotterdam-cream/30 text-[10px] tracking-widest uppercase" data-id="element-118">
                        Premium Service
                      </span>
                    </div>
                  </div>
                </a>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}